// Anexos gravados em BLOB como data URL — CNH, fotos de abordagem, CRLV.
//
// POR QUE EXISTE AQUI: estas funções nasceram em #324, dentro do componente da
// CNH, mas não têm nada de específico da CNH — e a #325 mostrou que o resto do
// sistema precisa da mesma coisa. Ver também #323, sobre esses arquivos
// viverem no banco.

// O BLOB chega como o JSON de um Buffer; o conteúdo é a data URL em texto.
export const paraDataUrl = valor => {
  if (valor === null || valor === undefined || valor === '') return '';
  return `${Buffer.from(valor, 'base64')}`;
};

export const ehPdf = dataUrl =>
  typeof dataUrl === 'string' && dataUrl.startsWith('data:application/pdf');

// Verificado no Chromium: <iframe src="data:application/pdf..."> RENDERIZA,
// mas <object data="data:..."> não, e NAVEGAR para `data:` é bloqueado
// (window.open, ou <a target=_blank>) — o clique não abre aba nenhuma, sem
// erro visível. Converter para Blob resolve os dois casos e ainda mantém a
// string de megabytes fora do DOM.
//
// Quem cria a URL precisa de URL.revokeObjectURL depois, senão o arquivo
// inteiro fica preso em memória.
export const dataUrlParaBlob = dataUrl => {
  const [cabecalho, base64] = String(dataUrl).split(',');
  const mime =
    (/data:([^;]+)/.exec(cabecalho) || [])[1] || 'application/octet-stream';
  const binario = window.atob(base64 || '');
  const bytes = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i += 1) {
    bytes[i] = binario.charCodeAt(i);
  }
  return new Blob([bytes], { type: mime });
};
